module.exports = __webpack_public_path__ + "img/south-medical.8eaf295f.jpg";